import React from "react";
import {Trans} from "@lingui/react/macro";
import MobPressable from "./MobPressable";
import {DynamicIcon} from "lucide-react/dynamic";
import {MOBCOLORS} from "../../configs/AppConfig";


export function MobAddButton({onClick,text,bordered,style={}})
{

    return(
        <MobPressable style={{
            //border:bordered?"2px solid "+MOBCOLORS.blue.color:null,
            display: "flex",
            alignItems: "center",
            justifyContent:"center",
            gap:5,
            backgroundColor: MOBCOLORS.blue.backgroundColor,
            color:MOBCOLORS.blue.color,
            padding: "5px 15px",
            borderRadius: 25,
            fontSize:15,
            cursor:"pointer",
            boxShadow:"0 2px 4px rgba(0, 0, 0, 0.08)",
            ...style
        }}
             onClick={onClick}
        >
            <DynamicIcon name={"plus"} color={MOBCOLORS.blue.color} size={15} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />

            <span>
                {text || (
                    <Trans>Ajouter</Trans>
                )}
            </span>
        </MobPressable>
    )
}
